import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  icon?: React.ReactNode;
  fullWidth?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, icon, fullWidth = false, className = '', ...props }, ref) => {
    return (
      <div className={fullWidth ? 'w-full' : ''}>
        {label && (
          <label className="block text-xs font-semibold text-slate-600 mb-1.5">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-600 pointer-events-none">
              {icon}
            </div>
          )}
          <input
            ref={ref}
            className={[
              'rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900',
              'placeholder-slate-400',
              'transition-colors duration-100',
              'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent',
              'disabled:bg-slate-50 disabled:cursor-not-allowed disabled:text-slate-600',
              error ? 'border-red-400 focus:ring-red-400' : '',
              icon ? 'pl-9' : '',
              fullWidth ? 'w-full' : '',
              className,
            ].filter(Boolean).join(' ')}
            {...props}
          />
        </div>
        {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
        {helperText && !error && <p className="text-xs text-slate-600 mt-1">{helperText}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
export default Input;
